module.exports = __webpack_public_path__ + "img/Learn-2.5d4472e9.png";